import { useEffect } from "react";

const useConsole = (key,data) => {
    useEffect(() => {
        console.log(key,data);
    }, [data])
}
 
export default useConsole;